<div [matMenuTriggerFor]="exibeTooltip ? menu : null" #trigger="matMenuTrigger"
  (mouseenter)="mouseEnter(trigger)" (mouseleave)="trigger.closeMenu()">
  <ng-content></ng-content>
</div>
<mat-menu #menu="matMenu" [hasBackdrop]="false">
  <div class="content-container">
    @if (tituloTooltip) {
      <div class="inline-element title">
        <p class="medium-emphasis titulo-tooltip">{{tituloTooltip}}</p>
      </div>
    }
    <ng-content select="[menuContent]"></ng-content>
  </div>
</mat-menu>